module.exports = __webpack_public_path__ + "img/8-August.2f27c66d.jpg";